import React from 'react';
import { Flex, Box } from 'rebass';
import { Formik, FormikConfig, Field } from 'formik';
import * as Yup from 'yup';

import {
  EmailField,
  FormHeader,
  FormSubHeader,
  BackToLogin,
  ErrorNotification,
  ButtonLarge,
} from '@mdlinx/component-library';

export interface PasswordAssistanceFormProps {
  onSubmit: FormikConfig<{ email: string; actionType: string }>['onSubmit'];
  onClickBack?: () => void;
  errorMessage?: string;
}

export const PasswordAssistanceForm = ({ onSubmit, onClickBack, errorMessage }: PasswordAssistanceFormProps) => {
  return (
    <Flex flexDirection="column">
      <FormHeader>Login Help</FormHeader>
      <Box mt="12px" />
      <FormSubHeader>
        Enter the email address associated with your account, and we’ll send you an email with a link.
      </FormSubHeader>
      <Box mt="20px" />
      {errorMessage && (
        <Box my="10px">
          <ErrorNotification errorMessage={errorMessage} />
        </Box>
      )}
      <Box width="100%" mb={['50px']}>
        <Formik
          initialValues={{ email: '', actionType: '' }}
          validationSchema={Yup.object({
            email: Yup.string()
              .email('Invalid email addresss')
              .required('Required'),
          })}
          onSubmit={onSubmit}
        >
          {formik => (
            <>
              <EmailField
                onSubmitClicked={() => formik.handleSubmit()}
                isSubmitButtonDisabled={!(formik.dirty && formik.isValid)}
              />
              <Field type="hidden" name="actionType" />
              <Box mt="20px">
                <ButtonLarge
                  type="submit"
                  disabled={!(formik.dirty && formik.isValid)}
                  onClick={() => {
                    formik.setFieldValue('actionType', 'password-reset');
                    formik.handleSubmit();
                  }}
                >
                  Send me a link to reset my password
                </ButtonLarge>
                <Box mt="10px" />
              </Box>
              <ButtonLarge
                type="submit"
                disabled={!(formik.dirty && formik.isValid)}
                onClick={() => {
                  formik.setFieldValue('actionType', 'login-link');
                  formik.handleSubmit();
                }}
              >
                Send me an auto-login link
              </ButtonLarge>
              <Box mt="10px" />
            </>
          )}
        </Formik>
      </Box>
      <BackToLogin onClick={onClickBack} />
    </Flex>
  );
};
